"use strict";

exports.__esModule = true;
exports.StripeChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _scales = require("../scales");
var _StripeChartWrapper = require("./StripeChartWrapper");
var _StripeChartContent = require("./StripeChartContent");
var _Time = require("../../Time");
var _utils = require("./utils");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
var _dec, _class, _StripeChart;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// With less than this the axis would leave the band a hairline, so the band
// takes the whole height and the axis is dropped.
var MIN_BAND_HEIGHT_WITH_AXIS = 22;
function makeState(props) {
  var interval = props.interval,
    width = props.width;
  var scale = props.scale;
  if (!scale) {
    scale = (0, _scales.createIntervalScale)(0, width, interval);
  }
  return {
    scale: scale
  };
}

/**
 * A stripe chart, optionally with a time axis.
 */
var StripeChart = exports.StripeChart = (_dec = _Time.TimeContext.withContext, _dec(_class = (_StripeChart = /*#__PURE__*/function (_Component) {
  function StripeChart() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(StripeChart, _Component);
  StripeChart.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    return makeState(props);
  };
  var _proto = StripeChart.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var scale = this.state.scale;
    var _this$props = this.props,
      timeline = _this$props.timeline,
      interval = _this$props.interval,
      height = _this$props.height;
    // The legacy chart keeps its axis whatever the height; the modern one
    // drops it rather than leave the band a hairline.
    var modern = Boolean(this.context && this.context.modern);
    var axis = modern ? Boolean(this.props.axis) && height - _utils.AXIS_HEIGHT >= MIN_BAND_HEIGHT_WITH_AXIS : this.props.axis;
    var intervalBetweenEvents = (0, _utils.findIntervalBetweenEvents)(interval.startMillis, interval.endMillis);
    var stripeChartWrapperProps = Object.assign({}, this.props, {
      axis: axis,
      scale: scale,
      timeline: timeline,
      intervalBetweenEvents: intervalBetweenEvents
    });
    return /*#__PURE__*/_react["default"].createElement(_StripeChartWrapper.StripeChartWrapper, stripeChartWrapperProps, function (_ref) {
      var showBrush = _ref.showBrush;
      return /*#__PURE__*/_react["default"].createElement(_StripeChartContent.StripeChartContent, _extends({}, _this2.props, {
        axis: axis,
        showBrush: showBrush,
        timeline: timeline
      }));
    });
  };
  return StripeChart;
}(_react.Component), _StripeChart.contextType = _UiDesignContext.UiDesignContext, _StripeChart.defaultProps = {
  axis: true,
  showBrush: false,
  brushIsLocked: false
}, _StripeChart)) || _class);